var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.5 4.5A2.5 2.5 0 0 1 4 2h10.5A2.5 2.5 0 0 1 17 4.5V19c0 .539.17 1.038.46 1.446.246.418.58.778.976 1.054H4.5a3 3 0 0 1-3-3v-14Zm3 .75a.5.5 0 0 1 .5-.5h8.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5v-4ZM5 12.5a.5.5 0 0 0 0 1h8.5a.5.5 0 0 0 0-1H5Zm-.5 2.75a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM5 17a.5.5 0 0 0 0 1h7.5a.5.5 0 0 0 0-1H5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.7 18.75V11H20c1.657 0 2.5 1.343 2.5 3v5a2.501 2.501 0 0 1-1.798 2.4h-.352a2.65 2.65 0 0 1-2.65-2.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewz);
export default __webpack_public_path__ + "static/media/newz.0b6b50749a07d820320517b4707ead6a.svg";
export { ForwardRef as ReactComponent };